module.exports = __webpack_public_path__ + "static/media/PY.bafa8987.png";